import React, { Fragment, useEffect, useState } from "react";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";

// redux toolkit
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { resendAgreementInvoice } from "../../slices/apps/agreementSlice";

// data dosyaları
import Invoice from "../../assets/images/invoice.png";

const AgreementInvoiceModal = ({ id, isOpen, toggle }) => {
  const dispatch = useDispatch();

  // states
  const { resendAgreementInvoiceLoading } = useSelector((state) => {
    return {
      resendAgreementInvoiceLoading:
        state.agreement.resendAgreementInvoiceLoading,
    };
  }, shallowEqual);

  const sendInvoice = async () => {
    try {
      const resultAction = await dispatch(resendAgreementInvoice(id));

      if (resultAction.meta.requestStatus === "fulfilled") {
        toggle();
      }
    } catch (error) {
      console.error("Failed:", error);
    }
  };

  return (
    <Modal size="md" isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader
        className="modal-title "
        id="myLargeModalLabel"
        toggle={toggle}
      >
        Faturalandır
      </ModalHeader>

      <ModalBody className="text-center text-dark">
        <img
          src={Invoice}
          alt="Invoice"
          id="candidate-img"
          className="img-fluid mb-4"
          style={{ height: "80px" }}
        />
        <h4 className="text-dark">
          Bu işlem sonucunda fatura oluşturulacak ve işlem geri alınamayacaktır.
          İşlemi onaylıyor musunuz?
        </h4>
        <div className="d-flex align-items-center gap-3 mt-5 justify-content-center">
          <Button
            className="btn btn-sm"
            color="primary"
            disabled={resendAgreementInvoiceLoading}
            onClick={sendInvoice}
          >
            Onayla
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default AgreementInvoiceModal;
